import { makeVar } from '@apollo/client';
export var standingsPageVar = makeVar({
    standingsNameSearchFieldInput: '',
    showUserDataRowInStatsTableButtonPressed: false,
    showStandingsPageButtonPressed: false,
    participantType: undefined,
    standingsUserInfoData: undefined,
    showTargetRowId: undefined
});
